import { RichtungDokumentSchema, aktuelleRichtung, gespeicherteRichtungsAntworten } from '../../shared/guide-richtung';

/** Read only the direction already authorized by the stage detail response.
 * No owner endpoint, form state, confirmation or network request in this view. */
export function GuideRichtungKontext({ richtung }: { richtung: unknown }) {
  if (richtung == null) return null;
  const doc = RichtungDokumentSchema.parse(richtung);
  const f = aktuelleRichtung(doc);
  if (!f) return null;
  const gespeichert = gespeicherteRichtungsAntworten(doc);
  const abgleichen = (doc.eingaben.at(-1)?.version ?? 0) > f.version;
  return <section className="guide-richtung" aria-label="So verstehe ich deine Richtung" data-ai-id="guide-richtung">
    <h3>So verstehe ich deine Richtung</h3>
    <p>{f.entwurf.zusammenfassung}</p>
    <p className="richtung-grenze">Lesende Ansicht der vorhandenen Richtung. Hier wird keine Antwort abgegeben.</p>
    <div className="richtung-arbeit"><strong>{abgleichen ? 'Bisher daraus abgeleitete Arbeit' : 'Daraus leiten wir die nächste Arbeit ab'}</strong>
      {abgleichen && <p>Die neue Richtung ist gespeichert. Der Berater gleicht die Ableitungen damit ab.</p>}
      <p>{f.entwurf.arbeitsstrecke}</p>{f.entwurf.unabhaengigeArbeit && <p>Unabhängig davon läuft weiter: {f.entwurf.unabhaengigeArbeit}</p>}
    </div>
    {f.entwurf.aussagen.map(a => {
      const k = gespeichert.korrekturen[a.id];
      return <article key={a.id}>
        <strong>{k?.einordnung === 'trifft_zu' ? 'Von dir ausdrücklich bestätigt' : k?.einordnung === 'anders' ? 'Von dir korrigiert · Beraterfassung abzugleichen' : k?.einordnung === 'nicht_relevant' ? 'Von dir als nicht relevant eingeordnet' : a.art === 'belegt' ? 'Aus deinen bisherigen Aussagen belegt' : a.art === 'annahme' ? 'Annahme des Beraters · unbestätigt' : 'Noch offen'}</strong>
        <p>{a.text}</p>{k?.text && <p>{k.text}</p>}
        {!!a.quellen.length && <details><summary>Quellen und Herkunft</summary>{a.quellen.map(q => {
          const source = f.quellen.find(s => s.art === q.art && s.id === q.id);
          return source ? <blockquote key={`${q.art}:${q.id}`}><p>{source.text}</p><small>{source.provenance} · {source.am}</small></blockquote> : null;
        })}</details>}
      </article>;
    })}
    {f.entwurf.fragen.map(q => <article key={q.id} className="richtung-frage">
      <strong>{q.frage}</strong><p>{q.luecke}</p>{q.empfehlung && <p>Empfehlung: {q.empfehlung}</p>}
      {gespeichert.antworten[q.id] && <p>Eine bisherige Antwort ist gespeichert.</p>}
      <ul>{q.optionen.map(o => <li key={o.id}>{gespeichert.antworten[q.id]?.optionen.includes(o.id) ? 'Gespeicherte Auswahl: ' : ''}{o.text}<p>{o.folge}</p></li>)}</ul>
      {gespeichert.antworten[q.id]?.notiz && <p>{gespeichert.antworten[q.id].notiz}</p>}
    </article>)}
    {!!doc.eingaben.length && <details><summary>Bisherige Antworten ({doc.eingaben.length})</summary>{doc.eingaben.map(e => <article key={e.eingabe.eingabeId}><small>{e.am}</small><p>{e.kontext}</p></article>)}</details>}
    <p className="richtung-grenze">Persönliche Richtung ist keine Zustimmung zu Versand, Kauf oder anderen Außenwirkungen.</p>
  </section>;
}
